import { useAppContext } from "../../application/App.Context";


export const useRequestType = () => {
    const { requestType } = useAppContext();

    const isInternal = requestType === "internal";
    const isExternal = requestType === "external";
    const isUndefined = requestType === "undefined";

return {
    isInternal,
    isExternal,
    isUndefined,
};

};
